module.exports = __webpack_public_path__ + "img/ukjent_annet_paavirkning_diverse.bdf1c9e5.jpg";